import { render, staticRenderFns } from "./EmpresasLista.vue?vue&type=template&id=3b26ca4c&scoped=true&"
import script from "./EmpresasLista.vue?vue&type=script&lang=js&"
export * from "./EmpresasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b26ca4c",
  null
  
)

export default component.exports